import { render, staticRenderFns } from "./msg-release.vue?vue&type=template&id=0cfb5a79&scoped=true&"
import script from "./msg-release.vue?vue&type=script&lang=js&"
export * from "./msg-release.vue?vue&type=script&lang=js&"
import style0 from "./msg-release.vue?vue&type=style&index=0&id=0cfb5a79&lang=scss&scoped=true&"
import style1 from "./msg-release.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb5a79",
  null
  
)

export default component.exports